import { render, staticRenderFns } from "./settings-organization-sso-page.vue?vue&type=template&id=2b38841a&scoped=true&"
import script from "./settings-organization-sso-page.vue?vue&type=script&lang=js&"
export * from "./settings-organization-sso-page.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-sso-page.vue?vue&type=style&index=0&id=2b38841a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38841a",
  null
  
)

export default component.exports